// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-company-icon-menu-group[data-v-ae0039d0]{padding-top:16px;padding-bottom:16px;margin-top:-16px;margin-left:-8px;margin-right:-8px}@media screen and (min-width: 768px){.app-company-icon-menu-group[data-v-ae0039d0]{display:none}}", ""]);
// Exports
module.exports = exports;
